// extracted by mini-css-extract-plugin
module.exports = {"ingredientImage":"Ingredient_ingredientImage__1lM_3","ingredientItem":"Ingredient_ingredientItem__2Fi2A"};